import { render, staticRenderFns } from "./CampaignsDonutCharts.vue?vue&type=template&id=30ca9615"
import script from "./CampaignsDonutCharts.vue?vue&type=script&lang=js"
export * from "./CampaignsDonutCharts.vue?vue&type=script&lang=js"
import style0 from "./CampaignsDonutCharts.vue?vue&type=style&index=0&id=30ca9615&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports